<template>
  <DeleteCompanyModal />
  <CreateCompanyModal />
  <div class="companies-list-card card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div
      v-if="getConfigurations.adm"
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
    >
      <div class="d-sm-flex align-items-center">
        <a
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#CreateCompanyModal"
        >
          Criar nova instalação
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </a>
      </div>
    </div>





    <div class="companies-list-body card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="companies-table-wrapper table-responsive">
        <table class="companies-table table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Nome
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                CPF/CNPJ
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Telefone
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Detalhes
              </th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="(value, key) in getUsersList" :key="key">
              
              <th class="company-name-cell shadow-none lh-1 fw-medium text-black-emphasis title ps-0" data-label="Nome">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ value.installation_name }}
                  </div>
                </div>
              </th>

              <td class="company-detail-cell shadow-none lh-1 fw-medium text-black-emphasis" data-label="CPF/CNPJ">
                {{ applyMaskCpfCnpj(value.cpf_cnpj) }}
              </td>

              <td class="company-detail-cell shadow-none lh-1 fw-medium text-black-emphasis" data-label="Telefone">
                {{ applyMaskPhone(value.installation_commercial_phone_01) }}
              </td>
              
              <td class="company-detail-cell company-status-cell shadow-none lh-1 fw-medium text-black-emphasis" data-label="Status">
                {{ value.active == 1 ? 'Ativo' : 'Inativo' }}
              </td>
              
              <td class="company-action-cell shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0 d-flex justify-content-end" data-label="Detalhes">
                <router-link
                  :to="'/installation/'+value.installation_id"
                  class="company-details-button position-relative transition border-0 fw-medium text-white p-10 rounded-1 bg-info d-flex text-decoration-none fit-content"
                  :aria-label="`Ver detalhes de ${value.installation_name}`"
                  :title="`Ver detalhes de ${value.installation_name}`"
                >
                  <!-- <i class="flaticon-search lh-1 me-8 position-relative top-1"></i> -->
                  <i class="flaticon-edit position-relative fs-16 d-flex lh-1"></i>
                </router-link>
                
              </td>

            </tr>
          
          
          
          
          </tbody>
        </table>
      </div>
    </div>








  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import DeleteCompanyModal from './DeleteCompanyModal.vue';
import CreateCompanyModal from './CreateCompanyModal.vue';

export default defineComponent({
  name: "UsersList",
  computed: {
    ...mapGetters([
      'getUsersList',
      'getConfigurations'
    ])
  },
  components: {
    DeleteCompanyModal,
    CreateCompanyModal 
  },
  methods: {...mapActions([
      "setCurrentDeleteUser"
    ]),
    applyMaskCpfCnpj(value) {
      if(!value){
        return 'Não informado';
      }

      if (value.replace(/\D/g, '').length > 11) {
        value = value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      } else {
        value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }

      return value;
    },
    applyMaskPhone(value) {
      if(!value){
        return 'Não informado';
      }

      if (value.replace(/\D/g, '').length > 10) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      return value;
    },
  }
});
</script>

<style scoped>
@media (max-width: 767px) {
  .companies-list-card {
    margin-right: -15px;
    margin-bottom: 0 !important;
    margin-left: -15px;
    border-radius: 0 !important;
  }

  .companies-list-body {
    padding-right: 8px !important;
    padding-left: 8px !important;
  }

  .companies-table-wrapper {
    overflow-x: visible;
  }

  .companies-table {
    display: block;
    white-space: normal !important;
  }

  .companies-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .companies-table tbody {
    display: grid;
    gap: 8px;
  }

  .companies-table tbody tr {
    position: relative;
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    column-gap: 8px;
    padding: 10px;
    border: 1px solid #e3e4ef;
    border-radius: 10px;
    background: linear-gradient(135deg, #fff 0%, #fcfcff 100%);
    box-shadow: 0 2px 7px rgba(43, 42, 63, 0.04);
  }

  .companies-table tbody th,
  .companies-table tbody td {
    display: block;
    width: auto;
    min-width: 0;
    padding: 7px 0;
    border: 0;
    line-height: 1.3 !important;
    text-align: left !important;
    white-space: normal;
  }

  .companies-table tbody th::before,
  .companies-table .company-detail-cell::before {
    display: block;
    margin-bottom: 2px;
    color: #8a8aa3;
    font-size: 9px;
    font-weight: 500;
    line-height: 1.2;
    text-transform: uppercase;
    content: attr(data-label);
  }

  .companies-table .company-name-cell {
    grid-column: 1 / -1;
    padding: 0 42px 8px 0;
    color: #38384f !important;
    font-size: 14px;
    font-weight: 600 !important;
    overflow-wrap: anywhere;
  }

  .companies-table .company-name-cell > div,
  .companies-table .company-name-cell > div > div {
    margin-left: 0 !important;
  }

  .companies-table .company-detail-cell {
    grid-row: 2;
    min-width: 0;
    padding: 6px 7px;
    border: 0;
    border-radius: 7px;
    color: #53536a !important;
    font-size: 12px;
    overflow-wrap: anywhere;
  }

  .companies-table .company-detail-cell:nth-of-type(1) {
    grid-column: 1 / 5;
    background-color: rgba(93, 95, 239, 0.055);
  }

  .companies-table .company-detail-cell:nth-of-type(2) {
    grid-column: 5 / 10;
    background-color: rgba(66, 139, 202, 0.055);
  }

  .companies-table .company-status-cell {
    grid-column: 10 / 13;
    color: #277757 !important;
    background-color: rgba(32, 160, 105, 0.075);
  }

  .companies-table .company-action-cell {
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 0;
  }

  .companies-table .company-details-button {
    width: 34px !important;
    min-width: 34px;
    height: 34px;
    align-items: center;
    justify-content: center;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 7px !important;
  }

  :global(.dark) .companies-table tbody tr {
    border-color: #45445e;
    background: #343348;
    box-shadow: none;
  }

  :global(.dark) .companies-table .company-name-cell {
    color: #f2f2f7 !important;
  }

  :global(.dark) .companies-table .company-detail-cell {
    color: #d9d8e4 !important;
    background-color: rgba(255, 255, 255, 0.045);
  }

  :global(.dark) .companies-table .company-status-cell {
    color: #7ed9ad !important;
    background-color: rgba(52, 199, 127, 0.1);
  }
}
</style>
